import paging from './../components/_paging';
import itemSearchCondition from './../components/_item_search_condition';

/**
 * 商品検索コンポーネント
 */
export default {
    data() {
        return {
            // 取得したアイテムリスト
            item_list: [],
            // 総ページ数
            pages: 0,
            // 現在のページ番号
            current_page: 1,
        };
    },
    components: {
        // ページング
        'paging': paging,
        // 検索条件
        'item-search-condition': itemSearchCondition,
    },
    computed: {
        // アイテムが取得されているか
        hasItems: function () {
            return (this.item_list.length > 0);
        },
    },
    methods: {
        // 初回検索実行
        firstSearch: async function () {
            // $refs.item_search_conditionがundefinedになることがあるのでawait
            while (typeof this.$refs.item_search_condition === 'undefined') {
                await this.$nextTick();
            }
            await this.$refs.item_search_condition.firstSearch();
        },
        // 検索実行
        searchItems: async function (page) {
            await this.$refs.item_search_condition.searchItems(page);
        }
    }
};
